import { useState } from "react";
import Sidebar from "../../components/Sidebar";
import Header from "../../components/Header";
import Table from "../../components/Table";
import api from "../../api";

const summaryColumns = [
    { name: "category", displayText: "Insumo", truncate: true },
    { name: "supplyType", displayText: "Tipo" },
    { name: "unitCost", displayText: "Costo unitario" },
    { name: "maxUses", displayText: "Usos máx." },
    { name: "totalQuantity", displayText: "Cantidad total" },
    { name: "totalCost", displayText: "Costo total" },
];

const detailColumns = [
    { name: "category", displayText: "Insumo", truncate: true },
    { name: "surgeryId", displayText: "Cirugía" },
    { name: "surgeryDate", displayText: "Fecha" },
    { name: "patient", displayText: "Paciente" },
    { name: "quantity", displayText: "Cantidad" },
    {
        name: "isFinalUse",
        displayText: "Último uso",
        render: (row) => (row.isFinalUse ? "Sí" : "No"),
    },
    { name: "cost", displayText: "Costo" },
];

export default function SupplyCostReportPage() {
    const today = new Date().toISOString().split("T")[0];
    const firstOfMonth = today.slice(0, 8) + "01";
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [startDate, setStartDate] = useState(firstOfMonth);
    const [endDate, setEndDate] = useState(today);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [report, setReport] = useState(null);

    const handleGenerate = async (event) => {
        event.preventDefault();
        setLoading(true);
        setError("");
        try {
            const response = await api.supplyCostReport.generate(
                startDate,
                endDate
            );
            setReport(response);
        } catch (e) {
            setError(e.detail || "Hubo un error al generar el reporte");
        } finally {
            setLoading(false);
        }
    };

    const summaryRows = report
        ? Object.entries(report.supplies).map(([category, supply]) => ({
              category,
              ...supply,
          }))
        : [];

    const detailRows = report
        ? Object.entries(report.supplies).flatMap(([category, supply]) =>
              supply.usages.map((usage) => ({ category, ...usage }))
          )
        : [];

    return (
        <div className="bg-gray-100 h-screen">
            <Sidebar
                currentScreen={"Reportes"}
                sidebarOpen={sidebarOpen}
                setSidebarOpen={setSidebarOpen}
            />
            <div className="md:pl-64 flex flex-col h-screen flex-1">
                <Header setSidebarOpen={setSidebarOpen} />
                <main className="flex-1 space-y-6 bg-gray-100 py-8 px-6 lg:px-8">
                    <h2 className="text-gray-600 text-4xl font-bold">
                        Costos de insumos por cirugía
                    </h2>
                    <form
                        onSubmit={handleGenerate}
                        className="flex flex-col sm:flex-row gap-3 items-end"
                    >
                        <div>
                            <label className="block text-sm font-medium text-gray-700">
                                Desde
                            </label>
                            <input
                                type="date"
                                value={startDate}
                                onChange={(e) => setStartDate(e.target.value)}
                                className="border border-gray-300 rounded-md bg-white sm:text-sm"
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700">
                                Hasta
                            </label>
                            <input
                                type="date"
                                value={endDate}
                                onChange={(e) => setEndDate(e.target.value)}
                                className="border border-gray-300 rounded-md bg-white sm:text-sm"
                            />
                        </div>
                        <button
                            type="submit"
                            disabled={loading}
                            className="px-4 py-2 border border-transparent shadow-sm text-sm font-semibold rounded-md text-white bg-primary hover:bg-primary disabled:opacity-50"
                        >
                            {loading ? "Generando..." : "Generar reporte"}
                        </button>
                    </form>
                    {error && <p className="text-sm text-red-600">{error}</p>}
                    {report && (
                        <>
                            <p className="text-2xl font-semibold text-gray-800">
                                Costo total: {report.totalCost}
                            </p>
                            <Table
                                module="reports"
                                columns={summaryColumns}
                                rows={summaryRows}
                            />
                            <h3 className="text-gray-600 text-2xl font-bold">
                                Detalle por cirugía
                            </h3>
                            <Table
                                module="reports"
                                columns={detailColumns}
                                rows={detailRows}
                            />
                        </>
                    )}
                </main>
            </div>
        </div>
    );
}
